// extracted by mini-css-extract-plugin
export var container = "index-module--container--2MWv-";
export var textBox = "index-module--textBox--tNSxr";
export var imgBox = "index-module--imgBox--2mZ09";